module.exports = __webpack_public_path__ + "img/sdm.fc0d7fd4.png";